import {useEffect} from "react"

const DocumentsScreen = () => {

	useEffect(() => {
		document.title = 'АТС24 — Маршрутизация'
	}, [])

	return (
		<>

		</>
	)
}

export default DocumentsScreen
